import type { PortalProfile } from '../lib/api.ts';
import { initials } from '../lib/format.ts';

interface Props {
  profile: PortalProfile;
}

/** The signed-in client's own identity (read-only) — avatar initials, name, email. */
export function ProfileBadge({ profile }: Props): JSX.Element {
  return (
    <div className="argus-user-menu portal-profile" aria-label="Your profile">
      <span className="argus-user-menu__avatar" aria-hidden="true">
        {initials(profile.full_name)}
      </span>
      <span className="portal-profile__text">
        <span className="argus-user-menu__name profile-name">{profile.full_name}</span>
        <span className="portal-profile__email">{profile.email}</span>
      </span>
    </div>
  );
}
